var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6960",
    "data-name": "Group 6960",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.237,
    height: 28.237,
    viewBox: "0 0 28.237 28.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3297",
    "data-name": "Rectangle 3297",
    width: 28.237,
    height: 28.237,
    fill: "#f76162"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14299",
    "data-name": "Path 14299",
    d: "M14.12,28.237a14.118,14.118,0,1,1,14.117-14.12A14.128,14.128,0,0,1,14.12,28.237m.03-25.428A11.31,11.31,0,1,0,25.428,14.1,11.328,11.328,0,0,0,14.15,2.809",
    transform: "translate(0 0)",
    fill: "#f76162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14300",
    "data-name": "Path 14300",
    d: "M108.32,111.1l2.272-2.285,5.217,5.253,5.232-5.246,2.263,2.265-5.21,5.189,5.268,5.233-2.278,2.268-5.234-5.257-5.257,5.283-2.194-2.233,5.231-5.2L108.32,111.1",
    transform: "translate(-101.723 -102.191)",
    fill: "#f76162"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIco);
export default __webpack_public_path__ + "static/media/incorrect-ico.f80b3c84dc2e4b395fa52cf92caef963.svg";
export { ForwardRef as ReactComponent };